export default "__VITE_PUBLIC_ASSET__430b64e9__"